import { DataSchema, makeDataLocationPath } from '@integration-app/sdk'
import { toHeaderCase } from 'js-convert-case'

import { Properties, Property } from '../Row/Properties'

type ActiveProperty = {
  name: string
  value?: string
}

export function FieldPropertiesList({
  propertiesSchema,
  properties,
  isRequired,
}: {
  properties: any
  propertiesSchema: DataSchema
  isRequired?: boolean
}) {
  const activeProperties: ActiveProperty[] = Object.keys(
    propertiesSchema.properties ?? {},
  )
    .filter((key) => !!properties?.[key])
    .map((key) => ({
      name: toHeaderCase(key),
      value: getPropertyValueString(key, properties?.[key]),
    }))

  if (isRequired) {
    activeProperties.push({
      name: 'Required',
      value: 'yes',
    })
  }

  return activeProperties.length ? (
    <Properties>
      {activeProperties.map((property, i) => (
        <Property key={i}>
          <Property.Name>
            {property.name}
            {property.value && ':'}
          </Property.Name>
          {property.value && (
            <Property.Value>
              {property.value.substring(0, 50)}
              {property.value.length > 50 ? '...' : ''}
            </Property.Value>
          )}
        </Property>
      ))}
    </Properties>
  ) : null
}

function getPropertyValueString(propertyKey: string, value: any) {
  switch (propertyKey) {
    case 'referenceCollection':
      return makeDataLocationPath(value)?.replace('/data/', '')
    case 'referenceRecords':
      return `${value?.length} items`
    default:
      return value?.toString()
  }
}
